import React from "react";
//styles
import styles from "./WelcomeOverviewStyles.module.scss";
import { Grid2 } from "@mui/material";
//icons
import { ReactComponent as NewOrgImage } from "../../Features/Admin/AdminAssets/svg/NewOrganization.svg";
import { ReactComponent as TextIcon } from "../../Features/Admin/AdminAssets/svg/barcode_reader.svg";
import CustomButton from "../CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";

function WelcomeOverview() {
  const navigate = useNavigate();
  const handleCreateOrg = () => {
    navigate("/account/create-organization");
  };
  return (
    <>
      <Grid2 className={styles.WelcomeDashboardContainer}>
        <Grid2 className={styles.createOrganization}>
          <Grid2 className={styles.flexBox}>
            <NewOrgImage className={styles.OrgImage} />
            <Grid2 className={styles.headerFlexBox}>
              <Grid2 className={styles.header}>
                Everything you Need to
                <span className={styles.headerColor}>
                  {" "}
                  Create an Organization
                </span>
              </Grid2>
              <Grid2 className={styles.subHeader}>
                Rocon’s vision is to empower developers with top-tier DevOps
                capabilities
              </Grid2>
              <CustomButton className={styles.btn} onClick={handleCreateOrg}>
                Create Organization
              </CustomButton>
            </Grid2>
          </Grid2>
          <Grid2 className={styles.infoContainer}>
            <Grid2>
              <Grid2 className={styles.flexLabel}>
                <TextIcon className={styles.IconColor} />
                <Grid2 className={styles.textLabel}>
                  Collaborate with teams
                </Grid2>
              </Grid2>
              <Grid2 className={styles.textDesc}>
                Work closely with cross-functional teams to achieve shared
                goals, foster innovation, and ensure efficient project
                execution.
              </Grid2>
            </Grid2>
            <Grid2>
              <Grid2 className={styles.flexLabel}>
                <TextIcon className={styles.IconColor} />
                <Grid2 className={styles.textLabel}>Create clients</Grid2>
              </Grid2>
              <Grid2 className={styles.textDesc}>
                Create and maintain strong client relationships by providing
                exceptional service, addressing client needs, and exceeding
                expectations.
              </Grid2>
            </Grid2>
            <Grid2>
              <Grid2 className={styles.flexLabel}>
                <TextIcon className={styles.IconColor} />
                <Grid2 className={styles.textLabel}>Role based access</Grid2>
              </Grid2>
              <Grid2 className={styles.textDesc}>
                Define and enforce granular access controls based on user roles
                and responsibilities, minimizing security risks.
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}

export default WelcomeOverview;
